import { render } from "./ParticipantEmailView.vue?vue&type=template&id=821b7698&ts=true"
import script from "./ParticipantEmailView.vue?vue&type=script&lang=ts"
export * from "./ParticipantEmailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__